module.exports = __webpack_public_path__ + "static/media/head of department.111b6d22.svg";